import { render, staticRenderFns } from "./preLogin.vue?vue&type=template&id=6c864ad4&scoped=true&"
import script from "./preLogin.vue?vue&type=script&lang=js&"
export * from "./preLogin.vue?vue&type=script&lang=js&"
import style0 from "./preLogin.vue?vue&type=style&index=0&id=6c864ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c864ad4",
  null
  
)

export default component.exports